'use strict';

var React = require('react');

const LayoutGroupContext = React.createContext({});

exports.LayoutGroupContext = LayoutGroupContext;
//# sourceMappingURL=LayoutGroupContext.cjs.map
